<template>
  <!-- 碎片活动管理-添加碎片 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="type === 1 ? '添加碎片' : '编辑碎片'"
      width="350px"
      @close="closeDialog"
    >
      <el-form
        :model="dataForm"
        ref="dataForm"
        label-width="100px"
        size="small"
        :rules="replyRules"
      >
        <el-form-item prop="name" label="碎片名称">
          <el-input placeholder="请输入碎片名称" v-model="dataForm.name">
          </el-input>
        </el-form-item>
        <el-form-item prop="image" label="图片">
          <el-upload
            class="avatar-uploader"
            :action="action"
            :data="{ disk: imgType }"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :before-upload="beforeImageUpload"
            :headers="headers"
            accept="image/*"
            name="file"
          >
            <img class="avatar" v-if="dataForm.image" :src="dataForm.image" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <p>推荐尺寸256 * 192（4:3）</p>
        </el-form-item>
        <el-form-item prop="category_id" label="碎片分组">
          <el-select
            style="width: 140px"
            v-model="dataForm.category_id"
            placeholder="请选择碎片分组"
          >
            <el-option
              v-for="item in groupList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import { getCookie } from '../../utils/cookie'
import saveFile from '@/utils/saveFile'

export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    type: {//数据
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      imgType: 'prize',//上传图片的种类 奖品
      dataForm: {
        name: '',
        image: '',
        category_id: ''
      },
      groupList: undefined,//分组列表
      replyRules: {//回复弹窗规则验证
      }
    }
  },
  computed: {
    ...mapState({
    }),
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${server}file`
    },
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    fromInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val && this.fromInfo) {
        this.dataForm = this.fromInfo
      }
    },
  },
  created() {
    this.getGroupData()//获取分组数据
  },
  methods: {
    getGroupData() {
      //获取分组数据
      this.loading = true
      getApiData('debris_category')
        .then(res => {
          this.groupList = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    submit() {
      //保存任务
      //表单验证后发起请求
      this.buttonLoading = true
      let params = this.dataForm
      if (this.type === 1) {
        postApiData('debris', params).then(res => {
          this.$message.success("添加成功")
          this.$emit('refresh')
          this.closeDialog()
        }).finally(() => {
          this.buttonLoading = false
        })
      } else if (this.type === 2) {
        patchApiData(`debris/${this.dataForm.id}`, params).then(res => {
          this.$message.success("编辑成功")
          this.$emit('refresh')
          this.closeDialog()
        }).finally(() => {
          this.buttonLoading = false
        })
      }
    },
    beforeImageUpload(file) {
      if (file.size > 2 * 1024 * 1024) {
        this.$message.error('图片尺寸过大，请选择2M大小以下的图片上传')
        return false
      }
    },
    handleUploadSuccess(res) {
      if (res.path) {
        this.dataForm.image = res.path
      } else {
        this.$message.error('上传失败')
      }
      this.$refs['dataForm'].validateField('image')
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
</style>